var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94914 9.79289C6.33967 9.40237 6.97283 9.40237 7.36336 9.79289L12.6562 15.0858L17.9491 9.79289C18.3397 9.40237 18.9728 9.40237 19.3634 9.79289C19.7539 10.1834 19.7539 10.8166 19.3634 11.2071L13.3634 17.2071C12.9728 17.5976 12.3397 17.5976 11.9491 17.2071L5.94914 11.2071C5.55862 10.8166 5.55862 10.1834 5.94914 9.79289Z",
    fill: "#0E8750"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.0d9a23b612ebb8d003bf7a4313db4cfb.svg";
export { ForwardRef as ReactComponent };